import {
    SummaryWrapper,
    TableWrapper,
} from '@/ui/routes/summary/summary.styles'
import { IssuesTable } from './components/issuesTable'
import { SecurityStatus } from './components/SecurityStatus'
import { SubHeader } from './components/SubHeader'
import { useUnifiedFilter } from '@core/hooks/useUnifiedFilter'
import { IssuesModule } from '@/core/modules/issues'
import { IssuesFilters as IssuesFiltersComponent } from './components/IssuesFilters'
import { useAllIssues } from '../issues/hooks/useAllIssues'
import { IssuesHeader } from './components/IssuesHeader'

const ASMSummaryRoute = () => {
    const { data } = useAllIssues()

    const {
        search,
        data: filteredIssues,
        allData: allIssues,
        activeFilters,
        filterConfig,
        handleFilterChange,
        handleSearchChange,
        handleFilterReset,
        getFilterOptions,
    } = useUnifiedFilter({
        filterModule: IssuesModule.filterModule,
        data,
    })

    return (
        <SummaryWrapper>
            <SecurityStatus />
            <SubHeader />
            <TableWrapper id="security-issues-table">
                <IssuesHeader
                    filteredIssues={filteredIssues}
                    allIssues={allIssues}
                />
                <IssuesFiltersComponent
                    search={search}
                    handleSearch={handleSearchChange}
                    clearFilters={handleFilterReset}
                    allItems={allIssues}
                    filteredItems={filteredIssues}
                    onFilterChange={handleFilterChange}
                    getFilterOptions={getFilterOptions}
                    filterConfig={filterConfig}
                    activeFilters={activeFilters}
                />
                <IssuesTable issues={filteredIssues} />
            </TableWrapper>
        </SummaryWrapper>
    )
}

export default ASMSummaryRoute
